import { GeneralFeedback } from '@quadminds/client-apis/agents';
import { useToast } from '@quadminds/mindkit';
import { useMutation } from '@tanstack/react-query';
import { agentsApi } from '../services/agents-api.service';

interface CreateGeneralFeedbackParams {
    setOpen: (open: boolean) => void;
    setFeedback: (feedback: string) => void;
    setSubmitting: (isSubmitting: boolean) => void;
}

const useCreateGeneralFeedback = ({ setOpen, setFeedback, setSubmitting }: CreateGeneralFeedbackParams) => {
    const { toast } = useToast();
    const createFeedbackMutation = useMutation({
        mutationKey: ['create-general-feedback'],
        mutationFn: async (generalFeedback: GeneralFeedback) => agentsApi.createGeneralFeedback(generalFeedback),
        onSuccess: () => {
            toast({
                description: '¡Feedback enviado con éxito!',
                variant: 'default',
            });
            setOpen(false);
            setFeedback('');
            setSubmitting(false);
        },
        onError: () => {
            toast({
                description: 'Hubo un error al enviar el feedback.',
                variant: 'destructive',
            });
        },
        onSettled: () => {
            setSubmitting(false);
        },
    });
    return {
        createFeedbackMutation,
    };
};

export default useCreateGeneralFeedback;
